import app from "flarum/common/app";
import extractText from "flarum/common/utils/extractText";
/**
 * Wrap `app.request` with consistent error feedback.
 *
 * On success, returns the deserialised response (typed as T).
 * On failure, surfaces a user-visible alert and returns null — the caller can
 * branch on the null without writing the same .catch() boilerplate every time.
 *
 * The alert text prefers the API's first `errors[].detail`, falling back to
 * `errors[].title`, then to the configured translation key, then to the
 * generic "something went wrong" string. Network errors (no `response`) get
 * the dedicated `errors.network` translation.
 */
export default async function apiCall(options, opts) {
  if (opts === void 0) {
    opts = {};
  }
  try {
    return await app.request(options);
  } catch (raw) {
    const err = raw;
    if (!opts.silent) {
      const detail = err?.response?.errors?.[0]?.detail;
      const title = err?.response?.errors?.[0]?.title;
      let msg;
      if (detail) {
        msg = detail;
      } else if (title) {
        msg = title;
      } else if (!err?.response) {
        msg = extractText(app.translator.trans("ziiven-verified.lib.errors.network"));
      } else {
        msg = extractText(app.translator.trans(opts.errorKey || "ziiven-verified.lib.errors.generic"));
      }
      app.alerts.show({
        type: "error"
      }, msg);
    }
    if (opts.rethrow) throw raw;
    return null;
  }
}
flarum.reg.add('ziiven-verified', 'common/utils/apiCall', apiCall);